export const EventCategory = {
  DRIVER: 'driver',
  SETTLEMENT: 'settlement',
  VEHICLE: 'vehicle',
  PAYOFF: 'payoff',
  APPLICATION_ACCOUNT: 'application-account',
  ONLINE_PAYMENT: 'online-payment',
  CASH_FLOW: 'cash-flow',
  INVOICE: 'invoice',
  REPORT: 'report',
  SETTING: 'setting',
  USER: 'user',
}

export const EventAction = {
  IDENTITY_SET: 'identity-set'
}
